export const DEACTIVATE_ZOOM_POPUP = Symbol('DEACTIVATE_ZOOM_POPUP');
export const ACTIVATE_ZOOM_POPUP = Symbol('ACTIVATE_ZOOM_POPUP');

/**
 * @description
 * Gets the user data required for every page on the site
 *
 * @returns {{}}
 */
export function deactivatePopup () {

	return {
		type: DEACTIVATE_ZOOM_POPUP
	};
}

/**
 * @description
 * Gets the user data required for every page on the site
 *
 * @returns {{}}
 */
export function activatePopup (image) {

	return {
		type: ACTIVATE_ZOOM_POPUP,
		image
	};
}
